const Minus = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-minus"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-minus"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M16.5,13.5h-9a1.5,1.5,0,0,1,0-3h9a1.5,1.5,0,0,1,0,3Z" />
    </svg>
  );
};

export default Minus;
